var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"or__container"},[_c('span',{staticClass:"line"}),_c('v-card-subtitle',[_vm._t("default",function(){return [_vm._v(" ODER ")]})],2),_c('span',{staticClass:"line"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }